import { render, staticRenderFns } from "./OrderToggle.vue?vue&type=template&id=3f3d9ca4&scoped=true&"
import script from "./OrderToggle.vue?vue&type=script&lang=js&"
export * from "./OrderToggle.vue?vue&type=script&lang=js&"
import style1 from "./OrderToggle.vue?vue&type=style&index=1&id=3f3d9ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d9ca4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VImg,VProgressCircular,VRow,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f3d9ca4')) {
      api.createRecord('3f3d9ca4', component.options)
    } else {
      api.reload('3f3d9ca4', component.options)
    }
    module.hot.accept("./OrderToggle.vue?vue&type=template&id=3f3d9ca4&scoped=true&", function () {
      api.rerender('3f3d9ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Order/components/OrderToggle.vue"
export default component.exports